import { Stack, Typography } from "@mui/material";
import React from "react";
import Kanban from "../myTask/components/KanbanBoard/Kanban";
import Loader from "../../components/Loader";
import manageColumnIcon from "../../styles/svg/Vector.svg";
import OpenCardDetail from "../board/components/Kanban/openCardDetail";
import { TooltipName } from "../../utils/Enums";
import "./watching.scss";
import { ToggleColumnMenu } from "./ToggleColumnMenu";
import { DeskTopHeader } from "./DeskTopHeader";
import { ListViewTable } from "./ListViewTable";
import { MobileHeader } from "./MobileHeader";
import { useWatchingColumnState } from "./hooks/useWatchingColumnState";
import { useWatchingPageState } from "./hooks/useWatchingPageState";

export default function WatchingComp() {
  const {
    data,
    isLoading,
    isRefetching,
    isMobile,
    gridView,
    workflows,
    workflowSteps,
    projects,
    cardId,
    inputValue,
    handleChange,
    getCardStatus,
    cardDetailItems,
  } = useWatchingPageState();
  const {
    anchorEl,
    open,
    selectedColumn,
    visibleColumns,
    handleOpenMenu,
    handleCloseMenu,
    handleSelectColumn,
    handleSelectAllColumns,
  } = useWatchingColumnState();

  return (
    <>
      {projects && cardId && (
        <OpenCardDetail cardsOnBoard={cardDetailItems} />
      )}
      {isMobile ? (
        <MobileHeader />
      ) : (
        <DeskTopHeader handleChange={handleChange} inputValue={inputValue} TooltipName={TooltipName} />
      )}
      {isLoading || isRefetching ? (
        <div className="loader-center">
          <Loader color={"black"} />
        </div>
      ) : (
        <>
          {data && !isLoading && !isRefetching && workflows
            ? gridView && (
              <Kanban
                cards={projects}
                workflowSteps={workflowSteps}
                isMyTaskView={true}
              />
            )
            : ""}
          {!gridView && (
            <div>
              <Stack
                direction="row"
                justifyContent="end"
                my={3}
              >
                <div
                  onClick={handleOpenMenu}
                  className="d-flex align-items-center"
                >
                  <img
                    src={manageColumnIcon}
                    width={14}
                    alt="manage column"
                    style={{ cursor: "pointer" }}
                  />
                  <Typography className="manage-board">
                    Manage Board Columns
                  </Typography>
                </div>
              </Stack>
              <ListViewTable
                projects={projects}
                columns={visibleColumns}
                getCradStatus={getCardStatus}
              />
            </div>
          )}
          <ToggleColumnMenu
            anchorEl={anchorEl}
            open={open}
            selectedColumn={selectedColumn}
            handleCloseMenu={handleCloseMenu}
            handleSelectColumn={handleSelectColumn}
            handleSelectAllColumns={handleSelectAllColumns}
          />
        </>
      )}
    </>
  );
}
